import React from "react";
import ReactDOM from "react-dom";
import Marked from "marked";
import ReactHtmlParser from "react-html-parser";
import "./index.css"


const preMarkedInit = `
# for H1
## for H2!
[for links](https://www.freecodecamp.org/learn)
\`<p>this is inline code</p>\`
\`\`\`
<h1>Hello world! this is a code block</h1>
<h1>Hello world! this is a code block</h1>
<h1>Hello world! this is a code block</h1>
\`\`\`
* listItem
  * nested listitem

>BlockQuote

**this is an image of markdown logo:**
![Markdown logo](https://upload.wikimedia.org/wikipedia/commons/thumb/4/48/Markdown-mark.svg/1280px-Markdown-mark.svg.png)
`
class Editor extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      preMarkedText: preMarkedInit,
      button: "up",
      display: "none"
    }
  }
  handleChange = (event) => {
    this.setState({
      preMarkedText: event.target.value
    })
  }

  handleArrow = (event) => {
    this.setState(state => {
      return state.button === "down"
      ? {button: "up", display: "none"}
      : {button: "down", display: "block"}
    });
  }

  render() {
    const markedText = ReactHtmlParser(Marked(this.state.preMarkedText, { breaks: true }));
    return (
      <div>
        <h2 style={{ textAlign: "center" }}>Please type your Markdown below:</h2>
        <textarea
          id="editor"
          value={this.state.preMarkedText}
          onChange={this.handleChange}
          placeholder="Enter your Markdown here..."
          cols="50"
          rows="10"
        />
        <hr />
        <h2>The preview:
          <button 
            className = {this.state.button}
            onClick = {this.handleArrow}
          >
            <i className="fa fa-chevron-down ">
            </i>
          </button>
        </h2>
        <Preview display={this.state.display}>
          {markedText}
        </Preview>
      </div>
    );
  }
}
const Preview = (props) => {
  return (
    <div style={{display: props.display}} id="preview">
      {props.children}
    </div>
  );
}


ReactDOM.render(<Editor />, document.getElementById("root"));